import { CastType } from '@/types/casts'
import plainCastLayouts from '../layouts/plain/plain'
import stationSwitcherLayouts from '../layouts/stationSwitcher/stationSwitcher'
import switcherLayouts from '../layouts/switcher/switcher'
import { ComputedRef, Ref, ref } from '@vue/composition-api'
import { Cast } from '@/modules/casts/classes'

export enum CastLayoutView {
  Broadcast = 'Broadcast',
  Caster = 'Caster',
  Mobile = 'Mobile',
  Producer = 'Producer',
  Station = 'Station'
}

let TESTING_LAYOUTS: Ref<CastLayoutView|null>|null = null

export const setTestingLayouts = (testingLayouts: CastLayoutView|null) => {
  if (process.env.NODE_ENV !== 'test') {
    console.warn('setTestingLayouts is a function that you should not call outside test files')
  }
  if (TESTING_LAYOUTS === null) {
    TESTING_LAYOUTS = ref(testingLayouts)
  } else {
    TESTING_LAYOUTS.value = testingLayouts
  }
}

export const getTestingLayouts = () => {
  if (TESTING_LAYOUTS === null) {
    return ref(null)
  } else {
    return TESTING_LAYOUTS
  }
}

export const getCastLayoutView = (cast: ComputedRef<Cast|null>): ComputedRef<CastLayoutView|null> => {
  const checkLayout: Record<CastType, (cast: ComputedRef<Cast|null>) => ComputedRef<CastLayoutView|null>> = {
    [CastType.Plain]: plainCastLayouts,
    [CastType.Switcher]: switcherLayouts,
    [CastType.FanRoom]: switcherLayouts,
    [CastType.StationSwitcher]: stationSwitcherLayouts
  }
  return checkLayout[cast.value?.castType ?? CastType.Plain](cast)
}
